import { CURRENCY } from '@/consts/currency'

export const BILLING_CURRENCY = CURRENCY.USD
